const PATIENTS_URL = process.env.API_URL + '/xugarhero/patient';
const NUTRITIONISTS_URL = process.env.API_URL + '/xugarhero/nutritionist/all';
const NUTRITIONIST_MY_PATIENTS_URL = process.env.API_URL + '/xugarhero/nutritionist/my-patients';
const UNASSIGNED_PATIENTS_URL = PATIENTS_URL + '/unassigned';

const getPatients = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PATIENTS_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};


const getUnassignedPatients = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(UNASSIGNED_PATIENTS_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getNutritionistsAndPrescriptors = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(NUTRITIONISTS_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const assignNutritionist = (context, patientId, body) => {
  return new Promise((resolve, reject) => {
    context.$http.post(PATIENTS_URL + '/' + patientId, body)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getMyPatients = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(NUTRITIONIST_MY_PATIENTS_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getPatients,
  getUnassignedPatients,
  getNutritionistsAndPrescriptors,
  assignNutritionist,
  getMyPatients
};



// WEBPACK FOOTER //
// ./src/brand/health/api/patient/index.js